import Country from "@bimproject/country";
import { Suspense, useState } from "react";
import { FaAngleDown } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import styled from "styled-components";

import { useDialog } from "~/src/modules/ui-kit";

import orderingFunctions from "./sort";
import * as S from "./styled";
import * as UI from "../../../../../../modules/ui-kit";
import SearchBait from "../../../components/SearchBait";
import Selection from "../../../components/Selection";


export default function CountriesFilter(props) {
    const { disabled, discovery, onChange, value } = props;

    const [Dialog, open] = useDialog();

    return (
        <S.Filter>
            <span>Countries</span>
            <Suspense>
                <Selection
                    disabled={ disabled }
                    items={
                        value
                            .map(
                                (countryCode) => (
                                    {
                                        id: countryCode,
                                        name: Country.fromCode(countryCode).name ?? countryCode,
                                    }
                                )
                            )
                            .sort(orderingFunctions.az)
                    }
                    onChange={ onChange }
                />
            </Suspense>
            {
                !disabled && (
                    <S.Button onClick={ open } type="button">[select Countries]</S.Button>
                )
            }
            <S.Dialog as={ Dialog }>
                <CountrySelection
                    discovery={ discovery }
                    onChange={ onChange }
                    value={ value }
                />
            </S.Dialog>
        </S.Filter>
    );
}

const Flag = styled(UI.Flag)`
    margin-right: .3em;
    vertical-align: middle;
`;

function CountrySelection(props) {
    const { children, discovery, onChange, value } = props;

    const [ordering, setOrdering] = useState("az");
    const [token, setToken] = useState("");

    if (!discovery) return "loading";

    function toggle(countryCode) {
        onChange(
            (countryCodes) => countryCodes.includes(countryCode)
                ? countryCodes.filter(
                    (x) => x !== countryCode
                )
                : [...countryCodes, countryCode]
        );
    }

    const items = discovery
        .map(
            (countryScan) => (
                {
                    id: countryScan.country,
                    name: Country.fromCode(countryScan.country).name ?? countryScan.country,
                    alpha2: Country.fromCode(countryScan.country).alpha2Code ?? "",
                    count: countryScan.count,
                }
            )
        )
        .filter(
            (country) => country.name.toLowerCase().includes(token.toLowerCase()) || country.id.toLowerCase() === token.toLowerCase()
        )
        .sort(orderingFunctions[ordering]);

    const filteredSelected = items.filter((country) => value.includes(country.id));
    const filteredOther = items.filter((country) => !value.includes(country.id));

    function countryRow(country) {
        return (
            <tr
                key={ country.id }
                onClick={ () => toggle(country.id) }
            >
                <td>
                    { country.alpha2 && <Flag code={ country.alpha2 } /> }
                    { country.name }
                </td>
                <td>{ country.count }</td>
            </tr>
        );
    }

    return (
        <S.Selection>
            <SearchBait>
                <div>
                    <input
                        onChange={ (event) => setToken(event.target.value) }
                        placeholder="Search"
                        type="text"
                        value={ token }
                    />
                    {
                        token && (
                            <button
                                onClick={ () => setToken("") }
                                type="reset"
                            >
                                <IoClose />
                            </button>
                        )
                    }
                </div>
            </SearchBait>
            <S.Table
                $hideHeaders={ filteredSelected.length === 0 || filteredOther.length === 0 }
            >
                <thead>
                    <tr>
                        <th>
                            <button onClick={ () => setOrdering(ordering === "az" ? "za" : "az") }>
                                Name
                                <UI.OrderIcon order={ { az: "ASC", za: "DESC" }[ordering] } />
                            </button>
                        </th>
                        <th>
                            <button onClick={ () => setOrdering(ordering === "90" ? "09" : "90") }>
                                # of products
                                <UI.OrderIcon order={ { "09": "ASC", 90: "DESC" }[ordering] } />
                            </button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="group-header">
                        <th colSpan={ 2 }>
                            <FaAngleDown />
                            Selected
                            <span>({ filteredSelected.length })</span>
                        </th>
                    </tr>
                    { filteredSelected.map(countryRow) }
                </tbody>
                <tbody>
                    <tr className="group-header">
                        <th colSpan={ 2 }>
                            <FaAngleDown />
                            Other
                            <span>({ filteredOther.length })</span>
                        </th>
                    </tr>
                    { filteredOther.map(countryRow) }
                </tbody>
            </S.Table>
            { children }
        </S.Selection>
    );
}
